// ---- UTM STORAGE (90 dias em localStorage) ----
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'];

// Função para sanitizar strings (menos agressiva para UTMs)
function sanitizeString(input: string): string {
  return input
    .replace(/[<>"']/g, '') // Remove apenas caracteres XSS críticos
    .replace(/&/g, 'e') // Substitui & por 'e' para manter legibilidade
    .slice(0, 200) // Aumenta limite para UTMs
    .trim();
}

export function persistUtmsFromLocation() {
  try {
    const qs = new URLSearchParams(window.location.search);
    const store = JSON.parse(localStorage.getItem('utm_store') || '{}');
    let changed = false;
    
    UTM_KEYS.forEach(k => {
      const v = qs.get(k);
      if (v) { 
        const sanitized = sanitizeString(v);
        if (sanitized && sanitized !== store[k]) {
          store[k] = sanitized; 
          changed = true; 
        }
      }
    });
    
    if (changed) {
      // Adicionar timestamp para controle de TTL
      store._timestamp = Date.now();
      localStorage.setItem('utm_store', JSON.stringify(store));
    }
  } catch { 
    console.warn('Erro ao persistir UTMs');
  }
}

export function getPersistedUtms() {
  try { 
    const store = JSON.parse(localStorage.getItem('utm_store') || '{}');
    
    // Verificar se os UTMs ainda são válidos (90 dias)
    if (store._timestamp) {
      const ageInDays = (Date.now() - store._timestamp) / (1000 * 60 * 60 * 24);
      if (ageInDays > 90) {
        localStorage.removeItem('utm_store');
        return {};
      }
    }
    
    // Sanitizar dados antes de retornar
    const sanitizedStore: Record<string, string> = {};
    UTM_KEYS.forEach(key => {
      if (store[key]) {
        sanitizedStore[key] = sanitizeString(store[key]);
      }
    });
    
    return sanitizedStore;
  } catch { 
    return {}; 
  }
}

export function pickUtmsFallback() {
  const url = new URLSearchParams(window.location.search);
  const store = getPersistedUtms();
  const out: Record<string, string> = {};

  UTM_KEYS.forEach(k => {
    const urlValue = url.get(k);
    const storeValue = store[k];
    const value = urlValue || storeValue || '';
    out[k] = sanitizeString(value);
  });

  return out;
}

// ---- Normalizadores simples ----
export const norm = {
  name: (s = '') => s.trim().replace(/\s+/g, ' '),
  email: (s = '') => s.trim().toLowerCase(),
  phoneSplit: (raw = '') => {
    const digits = String(raw).replace(/\D+/g, '');
    
    // Se tem 13 dígitos (55 + 2 dígitos DDD + 9 dígitos), pegar DDD correto
    if (digits.length === 13 && digits.startsWith('55')) {
      const ddd = digits.slice(2, 4); // Pega os dígitos 2-3 (DDD)
      const phone = digits.slice(4);  // Pega do dígito 4 em diante
      return { ddd, phone };
    }
    
    // Se tem 11 dígitos (2 dígitos DDD + 9 dígitos), usar lógica normal
    if (digits.length === 11) {
      const ddd = digits.slice(0, 2);
      const phone = digits.slice(2);
      return { ddd, phone };
    }
    
    // Se tem 10 dígitos (2 dígitos DDD + 8 dígitos), usar lógica normal
    if (digits.length === 10) {
      const ddd = digits.slice(0, 2);
      const phone = digits.slice(2);
      return { ddd, phone };
    }
    
    // Fallback para outros casos
    const ddd = digits.slice(0, 2);
    const phone = digits.slice(2);
    return { ddd, phone };
  }
};

// Função para limpar UTMs expirados (opcional)
export function cleanupExpiredUtms() {
  try {
    const store = JSON.parse(localStorage.getItem('utm_store') || '{}');
    if (store._timestamp) {
      const ageInDays = (Date.now() - store._timestamp) / (1000 * 60 * 60 * 24);
      if (ageInDays > 90) {
        localStorage.removeItem('utm_store');
      }
    }
  } catch {
    console.warn('Erro ao limpar UTMs expirados');
  }
}
